import React from 'react';
import './primary cta long.css'

const PrimaryctaLongsettings = (props) => {
    return ( 
        <button className='long-cta-bg-settings' onClick={props.onClick}>
            <nav className='yellow-cont-bg'>
                <h2 className='cta-text-primary'>{props.title}</h2>
            </nav>
        </button>
     );
}
 
export default PrimaryctaLongsettings;